export function useTrackConfirmEmailEvent() {
  return () => {
    fetch('/api/internal/caja/unverified-events', {
      body: JSON.stringify({
        step: 'verifyEmail'
      }),
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    });
  };
}
